// @flow

import { BaseService } from "./base-service";

import { Suburb } from "../model/suburb";
import { FetchApi } from "../model/fetch";

export class PostcodeService extends BaseService {
    constructor(
        fetchApi: FetchApi,
        options: {
            basepath: string
        }
    ) {
        super(
            fetchApi,
            Object.assign({}, options, {
                basepath: ""
            })
        );
    }
    queryPostcode = async (postcodeOrSuburb: string): Promise<Suburb[]> => {
        const suburbs: Suburb[] = await this.fetch(
            "/account/api/suburbs/search",
            { query: postcodeOrSuburb }
        );
        return suburbs.slice(0, 8);
    };
}
